// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Card from "./groupcard";
// import CreateGroup from './creategroup';
// import { readMyGroupsAction } from "../../store/Group/action";
// import { useNavigate } from "react-router-dom";
// import ReactModal from "react-modal";
// import { ImCross } from "react-icons/im";

// const Groups = ({church}) => {

//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();


//   // Get groups from Redux store
//   const getMemberAvatars = (groupMembers = []) => {

//     return groupMembers
//       .filter(member => member != null)
//       .map((member, index) => {
//         // Get profile picture URL
//         const img =
//           member?.details?.profilePicUrl ||
//           member?.profilePicUrl ||
//           member?.profilePic ||
//           member?.user?.profilePicUrl ||
//           `https://randomuser.me/api/portraits/${index % 2 === 0 ? "men" : "women"}/${(index % 50) + 1}.jpg`;

//         // Get name (firstName + lastName)
//         const firstName = member?.details?.firstName || member?.firstName || member?.user?.firstName || "";
//         const lastName = member?.details?.lastName || member?.lastName || member?.user?.lastName || "";
//         const name = `${firstName} ${lastName}`.trim() || `User ${index + 1}`;
//         const userAuthId=member?.userAuthId
//         // Return object with both image and name as you requested
//         return {
//           img: img,
//           name: name,
//           userAuthId:userAuthId
//         };
//       });
//   };

//   const {
//     myCricleGroupsList = [],
//     myCricleGroupsLoading,
//     myCricleGroupsError,
//     myCricleGroupsSuccess
//   } = useSelector(state => state.groups);
//   useEffect(() => {
//     // Fetch groups on component mount
//     fetchMyGroups();
//   }, []);

//   const fetchMyGroups = () => {
//     dispatch(readMyGroupsAction({
//       data: {},
//       callback: (result) => {
//         if (result.type === 1) {
//         } else {
//         }
//       }
//     }));
//   };

//   // Default images for groups
//   const defaultGroupImages = [
//     "https://images.pexels.com/photos/5935253/pexels-photo-5935253.jpeg",
//     "https://images.pexels.com/photos/3184405/pexels-photo-3184405.jpeg",
//     "https://images.pexels.com/photos/3772612/pexels-photo-3772612.jpeg",
//     "https://images.pexels.com/photos/5340065/pexels-photo-5340065.jpeg",
//     "https://images.pexels.com/photos/5527851/pexels-photo-5527851.jpeg",
//     "https://images.pexels.com/photos/6150464/pexels-photo-6150464.jpeg",
//   ];

//   // Format API groups for Card component
//   const formattedGroups = myCricleGroupsList.map((group, index) => {
//     const membersFromApi = getMemberAvatars(group.groupMembers);

//     return {
//       id: group._id,
//       title: group.groupName || "Unnamed Group",
//       image: group?.groupCoverImageUrl??defaultGroupImages[0],
//       members: membersFromApi,
//       createdDate: group.createdDate,
//       apiData: group
//     };
//   });

//   // Handle group creation success
//   const handleGroupCreated = () => {
//     setShowCreateModal(false);
//     fetchMyGroups(); // Refresh the list
//   };

//   // Show loading state
//   if (myCricleGroupsLoading) {
//     return (
//       <div className="min-h-screen text-white py-10 mx-auto w-full px-4">
//         <div className="flex justify-center items-center h-64">
//           <span className="ml-4 text-lg">Loading your groups...</span>
//         </div>
//       </div>
//     );
//   }

//   // Show error state
//   if (myCricleGroupsError) {
//     return (
//       <div className="min-h-screen text-white py-10 mx-auto w-full px-4">
//         <div className="text-center">
//           <div className="text-red-500 text-xl mb-4">Error loading groups</div>
//           <p className="mb-6">{myCricleGroupsError}</p>
//           <button
//             onClick={fetchMyGroups}
//             className="px-6 py-2 bg-blue-600 rounded-lg hover:bg-blue-700 transition"
//           >
//             Try Again
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="min-h-screen text-white py-10 mx-auto w-full px-4">
//         {myCricleGroupsList.length === 0 ? (
//           <div className="text-center py-20">
//             <div className="text-6xl mb-4">👥</div>
//             <h2 className="text-2xl font-semibold mb-4">No groups yet</h2>
//             <p className="text-gray-400 mb-8">Create your first group to get started!</p>
//             <button
//               onClick={() => setShowCreateModal(true)}
//               className="px-8 py-3 bg-[#F8BA34] text-black rounded-lg hover:bg-yellow-500 transition text-lg font-semibold"
//             >
//               Create Your First Group
//             </button>
//           </div>
//         ) : (
//           <>
//             {/* Groups Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
//               {/* Create Group Card */}
//               <Card
//                 isCreateCard
//                 onClick={() => setShowCreateModal(true)}

//               />

//               {/* Group Cards from API */}
//               {formattedGroups.map((group) => (
//                 <Card
//                   key={group.id}
//                   title={group.title}
//                   image={group.image}
//                   members={group.members}
//                   createdDate={group.createdDate}
//                   apiData={group.apiData}
//                   onClick={() => navigate(`/group/${group.id}`, { state: group })}
//                   church={church}
//                 />
//               ))}
//             </div>

//             {/* Add more content button */}
//             {/* <div className="mt-10 text-center">
//               <button
//                 onClick={() => setShowCreateModal(true)}
//                 className="px-6 py-3 bg-[#F8BA34] text-black rounded-lg hover:bg-yellow-500 transition font-semibold"
//               >
//                 + Create Another Group
//               </button>
//             </div> */}
//           </>
//         )}
//       </div>

//       {/* Create Group Modal */}
//       <ReactModal
//   isOpen={showCreateModal}
//   onRequestClose={() => setShowCreateModal(false)}
//   appElement={document.getElementById('root')}
//   className="modal-content"
//   overlayClassName="modal-overlay"
//   style={{
//     content: {
//       top: '5%',
//       right: '0',
//       bottom: '5%',
//       width: '100%',
//       height: '90%',
//       backgroundColor: 'rgba(0, 0, 0, 0.95)',
//       border: 'none',
//       borderRadius: '0',
//       padding: '0',
//       position: 'fixed',
//       zIndex: 99999,
//       transform: showCreateModal ? 'translateX(0)' : 'translateX(100%)',
//       transition: 'transform 0.3s ease-in-out',
//     },
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.8)',
//       zIndex: 99999,
//     }
//   }}
// >
//         <div className="h-full w-full bg-black">
//           {/* Modal Header */}
//           <div className="flex justify-between items-center p-6 border-b border-[#28292a]">
//             <div className="flex items-center gap-4">
//               <h2 className="text-2xl font-bold text-white">Create New Group</h2>
//             </div>
//             <button
//               onClick={() => setShowCreateModal(false)}
//               className="text-white hover:text-red-500 text-2xl"
//             >
//               <ImCross />
//             </button>
//           </div>

//           {/* Modal Content */}
//           <div className="h-[calc(100vh-180px)] overflow-y-auto">
//             <CreateGroup
//               onBack={() => setShowCreateModal(false)}
//               onGroupCreated={handleGroupCreated}
//               church={church}
//             />
//           </div>
//         </div>
//       </ReactModal>
//     </>
//   );
// };

// export default Groups;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { readMyGroupsAction,deleteGroupAction } from "../../store/Group/action";
import { sendNotificationToOneAction } from "../../store/Users/UsersAction";
import CustomTable from "../../components/universal/CustomTable";
import { FaBell } from "react-icons/fa";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import ConfirmToast from "../../components/universal/ConfirmToast";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import CreateGroup from "./creategroup"; // adjust path if needed

const Groups = ({ church }) => {
  const dispatch = useDispatch();

  const {
    myCricleGroupsList = [],
    myCricleGroupsLoading,
    myCricleGroupsError,
  } = useSelector((state) => state.groups);

  /** ============================
   * Notification Modal State
   * ============================ */
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);

  const [notificationForm, setNotificationForm] = useState({
    notification_title: "",
    notification_description: "",
  });

  /** ============================
   * Fetch Groups
   * ============================ */
  useEffect(() => {
    dispatch(readMyGroupsAction({ data: {} }));
  }, [dispatch]);

  /** ============================
   * Helpers
   * ============================ */
  const getMemberAvatars = (groupMembers = []) =>
    groupMembers
      .filter(Boolean)
      .map((member, index) => ({
        img:
          member?.details?.profilePicUrl ||
          member?.profilePicUrl ||
          member?.profilePic ||
          `https://randomuser.me/api/portraits/${
            index % 2 === 0 ? "men" : "women"
          }/${(index % 50) + 1}.jpg`,
        name:
          `${member?.details?.firstName || ""} ${
            member?.details?.lastName || ""
          }`.trim() || `User ${index + 1}`,
        userAuthId: member?.userAuthId,
      }));

  /** ============================
   * Table Headers (IMPORTANT)
   * ============================ */
  const headers = [
    { headerName: "Group Name", headerId: "groupName", width: "w-1/4" },
    { headerName: "Overall Progress", headerId: "progressCol", width: "w-1/4" },
    { headerName: "Notification", headerId: "notification", width: "w-1/4" },
    { headerName: "Actions", headerId: "actions", width: "w-1/4" },
  ];

  /** ============================
   * Table Data
   * ============================ */
  const tableData = myCricleGroupsList.map((group) => ({
    ...group, // 👈 important (row data passed to handlers)

    groupName: group.groupName || "Unnamed Group",

    progressCol: (
      <div className="flex items-center gap-2">
        <div className="w-24 bg-neutral-800 rounded-full h-1.5 overflow-hidden">
          <div
            className="bg-yellowish h-1.5 rounded-full"
            style={{ width: `${group.overallProgress || 0}%` }}
          />
        </div>
        <span className="text-xs text-greyish font-semibold">{group.overallProgress || 0}%</span>
      </div>
    ),

    notification: (
      <FaBell
        className="text-yellowish cursor-pointer text-lg"
        onClick={() => {
          setSelectedGroup(group);
          setShowSendModal(true);
        }}
      />
    ),
  }));

  /** ============================
   * Notification Handlers
   * ============================ */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNotificationForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendNotification = () => {
    const members = getMemberAvatars(selectedGroup?.groupMembers);

    if (!members.length) {
      toast.error("No members to notify");
      return;
    }

    if (!notificationForm.notification_title.trim()) {
      toast.error("Please enter notification title");
      return;
    }

    if (!notificationForm.notification_description.trim()) {
      toast.error("Please enter notification description");
      return;
    }

    members.forEach((member) => {
      dispatch(
        sendNotificationToOneAction({
          userAuthId: member.userAuthId,
          notification_title: notificationForm.notification_title,
          notification_description: notificationForm.notification_description,
          groupId: selectedGroup?._id,
          churchObjId: church?._id,
        })
      );
    });

    toast.success("Notification sent to all members!");
    setShowSendModal(false);
    setNotificationForm({
      notification_title: "",
      notification_description: "",
    });
  };

  /** ============================
   * Loading / Error
   * ============================ */
  if (myCricleGroupsLoading) {
    return <div className="text-white p-6">Loading groups...</div>;
  }

  if (myCricleGroupsError) {
    return (
      <div className="text-red-500 p-6">
        Failed to load groups. Please try again.
      </div>
    );
  }

  /** ============================
   * Render
   * ============================ */
  return (
    <>
    <div className="flex justify-end mb-4">
    <button
  onClick={() => {
    setEditingGroup(null);   // 👈 important
    setShowCreateModal(true);
  }}
  className="flex items-center gap-2 text-[13px] text-yellowish border px-6 py-2 border-yellowish bg-blackish rounded-xl hover:bg-yellowish hover:text-black transition-colors mr-4"
>
  + Create Group
</button>

</div>

      <div className="bg-[#191919] min-h-screen p-4">
        <CustomTable
          headers={headers}
          data={tableData}
          searchFor="Groups"
          heightDesktop="h-[70vh]"
          showSearch={true}
          emptyStateMessage="No groups found"

          /** SAME AS AllPlans */
          handleEditClick={(row) => {
            setEditingGroup(row);      // 👈 store clicked row
            setShowCreateModal(true);  // 👈 open modal
          }}


          handleDeleteClick={(row) => {
            confirmAlert({
              customUI: ({ onClose }) => (
                <ConfirmToast
                  title="Delete Group"
                  message={`Are you sure you want to delete "${row.groupName}"? This action cannot be undone.`}
                  onClose={onClose}
                  onSuccess={() => {
                    dispatch(
                      deleteGroupAction({
                        data: { _id: row._id },
                        callback: (res) => {
                          if (res.type === 1) {
                            toast.success("Group deleted successfully!", {
                              position: "top-right",
                              autoClose: 3000,
                            });

                            // Reload groups (same as AllPlans)
                            dispatch(readMyGroupsAction({ data: {} }));
                          } else {
                            toast.error(res.error || "Failed to delete group!", {
                              position: "top-right",
                              autoClose: 3000,
                            });
                          }
                          onClose();
                        },
                      })
                    );
                  }}
                />
              ),
            });
          }}

        />
      </div>

      {/* ================= Notification Modal ================= */}
      {showSendModal && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-70 z-40"
            onClick={() => setShowSendModal(false)}
          />

          <div className="fixed top-1/2 right-0 h-[90vh] w-[90%] bg-blackish z-[9999] -translate-y-1/2">
            <div className="h-full flex flex-col">
              <div className="flex justify-between items-center h-[64px] px-4 border-b border-[#28292a]">
                <h3 className="text-white font-semibold text-lg">
                  Send Notification
                </h3>
                <button
                  onClick={() => setShowSendModal(false)}
                  className="text-greyish hover:text-white"
                >
                  ✕
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-4 space-y-6">
                <div>
                  <label className="text-xs text-greyish">Group Members</label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {getMemberAvatars(
                      selectedGroup?.groupMembers
                    ).map((m, i) => (
                      <img
                        key={i}
                        src={m.img}
                        title={m.name}
                        className="w-10 h-10 rounded-full border-2 border-yellowish"
                      />
                    ))}
                  </div>
                </div>

                <div>
                  <label className="text-xs text-greyish">
                    Notification Title *
                  </label>
                  <input
                    name="notification_title"
                    value={notificationForm.notification_title}
                    onChange={handleInputChange}
                    className="w-full mt-2 bg-[#111] p-2 rounded border border-[#28292a] text-white"
                  />
                </div>

                <div>
                  <label className="text-xs text-greyish">
                    Notification Description *
                  </label>
                  <textarea
                    rows="5"
                    name="notification_description"
                    value={notificationForm.notification_description}
                    onChange={handleInputChange}
                    className="w-full mt-2 bg-[#111] p-2 rounded border border-[#28292a] text-white"
                  />
                </div>
              </div>

              <div className="p-4 border-t border-[#28292a] flex justify-end gap-4">
                <button
                  onClick={() => setShowSendModal(false)}
                  className="px-6 py-2 border border-greyish text-greyish rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendNotification}
                  className="px-6 py-2 border border-yellowish text-yellowish rounded hover:bg-yellowish hover:text-black"
                >
                  Send Notification
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <ReactModal
  isOpen={showCreateModal}
  onRequestClose={() => setShowCreateModal(false)}
  appElement={document.getElementById("root")}
  style={{
    content: {
      top: "5%",
      right: "0",
      bottom: "5%",
      width: "98%",
      height: "90%",
      backgroundColor: "rgba(0, 0, 0, 0.95)",
      border: "none",
      padding: "0",
      position: "fixed",
      zIndex: 99999,
      transform: showCreateModal
        ? "translateX(0)"
        : "translateX(100%)",
      transition: "transform 0.3s ease-in-out",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: 99999,
    },
  }}
>
  <div className="h-full w-full bg-black">
    {/* Header */}
    <div className="flex justify-between items-center p-6 border-b border-[#28292a]">
      <h2 className="text-2xl font-bold text-white">Create New Group</h2>
      <button
        onClick={() => setShowCreateModal(false)}
        className="text-white hover:text-red-500 text-xl"
      >
        <ImCross />
      </button>
    </div>

    {/* Content */}
    <div className="h-[calc(100vh-180px)] overflow-y-auto">
      <CreateGroup
        church={church}
        editData={editingGroup}     // 👈 send selected row data

        onBack={() => setShowCreateModal(false)}
        onGroupCreated={() => {
          setShowCreateModal(false);
          dispatch(readMyGroupsAction({ data: {} }));
        }}
      />
    </div>
  </div>
</ReactModal>

    </>
  );
};

export default Groups;

